import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=5e14c81e&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e14c81e",
  null
  
)

export default component.exports